import { Button, IconButton, Stack, Tooltip } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function AuthoringRecommendationRowActions({ routeTo, applyDisabled, onOpenSource, onApply }) {
    return (
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ flexShrink: 0 }}>
            <If value={Boolean(routeTo)}>
                <Tooltip title="Open source">
                    <IconButton size="small" color="primary" onClick={onOpenSource}>
                        <Iconify icon="mdi:open-in-new" width={18} />
                    </IconButton>
                </Tooltip>
            </If>
            <Button size="small" color="primary" disabled={applyDisabled} onClick={onApply} sx={{ minWidth: 0 }}>
                Apply
            </Button>
        </Stack>
    )
}
